/**
 * Created by shem.mahluf on 14/08/2016.
 */

import PropTypes from 'prop-types';

import React from 'react';
import {Link} from 'react-router-dom';
import Style from './srListItem.scss';
import C from '../../constants/scoreBoard';
import C_R from '../../constants/routes';
import Cx from 'classnames';
import BadgesContainer from './badgesContainer';
import ColumnsContainer from './columnsContainer';
import ToolTip from './toolTip';
/**
 *returns a react object with the full List Item type object
 */
const PendingActionListItem = function ({listItemId, listItemData,listBadgesData,listColumnsData,tabName, isPendingActionItem, subTabName, intlObject}) {
    let reqLink = `${C_R.ACTION_PATH}/${listItemId}`;
    if(listItemData[C.PENDING_STATUS]){
        reqLink+=`:${listItemData[C.PENDING_STATUS].value}`;
    }

    let detailsClass;
    switch (listColumnsData.length) {
        case 0:
            detailsClass = Cx(Style.zeroColumnDetails,'zeroColumnDetails');
            break;
        case 1:
            detailsClass = Cx(Style.oneColumnDetails,'oneColumnDetails');
            break;
        default:
            detailsClass = Cx(Style.defaultDetails,'defaultDetails');
            break;
    }
    return (
        <Link to={reqLink} className={Style.noDecoration}>
            <div className={Cx(Style.requestListItem, 'requestListItem')}>
                <div className={detailsClass}>
                    <div className={Style.requestListItemSubject}
                         title={`${intlObject['ssp.idPrefix']}${listItemData[C.PENDING_SR_ID].valueCaption} - ${listItemData[C.PENDING_TITLE].valueCaption} - ${tabName} - ${subTabName}`}>
                        <strong>{`${intlObject['ssp.idPrefix']}${listItemData[C.PENDING_SR_ID].valueCaption}`}</strong>
                        <span>&nbsp;-&nbsp;{listItemData[C.PENDING_TITLE].valueCaption}<span className='arrowRtSm'></span>{tabName}<span className='arrowRtSm'></span>{subTabName}</span>
                    </div>
                    <BadgesContainer
                        listItemId={listItemId}
                        listBadgesData={listBadgesData}
                    />
                </div>
                <ColumnsContainer
                    listColumnsData={listColumnsData}
                    isPendingActionItem={isPendingActionItem}
                />
                <ToolTip
                    listBadgesData={listBadgesData}
                    listColumnsData={listColumnsData}
                />
                <div className='clearfix'></div>
            </div>
        </Link>
    );
};

PendingActionListItem.propTypes = {
    listItemId: PropTypes.string.isRequired,
    listItemData: PropTypes.object.isRequired,
    listBadgesData: PropTypes.array.isRequired,
    listColumnsData: PropTypes.array.isRequired,
    subTabName:PropTypes.string.isRequired,
    tabName:PropTypes.string.isRequired,
    isPendingActionItem:PropTypes.bool.isRequired,
    intlObject:PropTypes.object.isRequired

};

export default PendingActionListItem;



// WEBPACK FOOTER //
// ./components/Scoreboard/pendingActionListItem.js